import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';

const DisiplineScoreSave = ({ schoolClassId, schoolClassDegree, monthInd, onChange, onClose}) => {
    const [loading, setLoading] = useState(true);
    const [errorVisible, setErorVisible] = useState(false);
    const [continualTest, setContinualTest] = useState(null);
    const [continualTestId, setContinualTestId] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
      var k = parseInt(monthInd);
      var params = {login:util.getTrustedUser(), schoolClassId:schoolClassId, monthInd:k};
      var url = config.Server+`/school/month/disipline-score/get`;

      setLoading(true);
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  var ct = response.data;
                  setContinualTestId(ct.disiplineScoreId)
                  for(var i=0;i<ct.students.length;i++){
                    ct.students[i]["scoreStr"] = String(ct.students[i].score);
                  }
                    ct.students.sort((a, b) => {
                        const fn = a.student.lastname.localeCompare(b.student.lastname, 'fa');
                        if (fn !== 0) return fn;
                        return a.student.firstname.localeCompare(b.student.firstname, 'fa');
                    });
                   console.log("students after sort is> ", ct.students);
                 setContinualTest(ct);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  //setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              //setLoading(false);
          });
     
    }, []);

    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{onClose()}} saving={saving} />
        )
    }
    const saveItem = function(){
      setSaving(true);
      var tmp = continualTest.students;
      var students = [];
      for(var i=0;i<tmp.length;i++){
        var hasScore = true;
        if(tmp[i].scoreStr == null) tmp[i].scoreStr = "";
        if(tmp[i].scoreStr == "") hasScore = false;
        if(!util.IsNumber(tmp[i].scoreStr)) hasScore = false;

        var score = 0;
        if(hasScore) {
            score = parseFloat(tmp[i].scoreStr);
        }
        students.push({studentId:tmp[i].student.id, score:score});
      }
      var url = config.Server+`/school/month/disipline-score/save`;
      var params = {login:util.getTrustedUser(), id:continualTestId, schoolClassId:schoolClassId, monthInd:continualTest.monthInd, students:students};
      console.log("save param is>", params);
      console.log("save url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                  onChange(schoolClassId, continualTestId);

                  onClose();  

                  setSaving(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
        
    }
    const onInputChange = function(e, index){
        var tmp = {...continualTest};
        var val = '';
        val = (e.target && e.target.value) || '';
        var v = val;
        if(v == null) v = "";
        tmp.students[index].scoreStr = v;
        setContinualTest(tmp);
    }
    const onScoreCheckboxChange = (e, score, index) => {
        var tmp = {...continualTest};
        tmp.students[index].scoreStr = String(score);
        tmp.students[index].score = score;
        setContinualTest(tmp);
    }
    const getCheckedState = function (index, target){
        var score = continualTest.students[index].score;
        if(target == 1){
            if(score>util.describableScores.good)return true;
            else return false;
        }
        else if(target == 2){
            if((score>util.describableScores.acceptable)&&(score<=util.describableScores.good)) return true;
            else return false;
        }
        else if(target == 3){
            if((score>=10)&&(score<=util.describableScores.acceptable)) return true;
            else return false;
        }
        else if(target == 4){
            if(score<10) return true;
            else return false;
        }

        return false;
    }
    const createScoreGetter = function(index){
        if((schoolClassDegree >=1) && (schoolClassDegree <=6)){
            return(
                <>
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.veryGood, index)}} checked={getCheckedState(index, 1)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.good, index)}} checked={getCheckedState(index, 2)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.acceptable, index)}} checked={getCheckedState(index, 3)} />
                    </td>                
                    <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                        <Checkbox onChange={(e)=>{onScoreCheckboxChange(e, util.describableScores.rejected, index)}} checked={getCheckedState(index, 4)} />
                    </td>                
                </>
            )

        }
        else{
            return(
                <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                    <InputText keyfilter={"num"} value={continualTest.students[index].scoreStr} onChange={(e) => onInputChange(e, index)} maxLength={5} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}}/>
                </td>                
            )
        }
    }
    return (
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت نمره انضباط ماهانه" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
            {
                loading?
                <>
                    loding...
                    <br/>
                    <Skeleton />
                </>
                :
                <>
                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <tbody>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>نمره نهائی</td>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>کلاس: {continualTest.schoolClass.name}</td>
                            </tr>
                            <tr>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>ماه ثبتی: {util.getMonthName(monthInd)}</td>
                                <td style={{padding:"3px",textAlign:"right", border:"1px solid #b0b0b0"}}>درس: انضباط</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    در صورتی که نمرات مثبت یا منفی نمایش داده نمی شوند و هیج اثری بر نمره انضباط ماهانه ندارند، در صفحه قبل پیش از ثبت نمره اقدام به حذف نمره انضباط نمائید
                                </td>
                            </tr>
                            <tr><td colSpan={2}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                    <table style={{width:"100%", borderCollapse:"collapse"}}>
                        <thead>
                            <tr style={{height:"100px"}}>
                                <th style={{width:"20px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>#</th>
                                <th style={{width:"100px", backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>کد ملی</th>
                                <th style={{backgroundColor:"#e5e5e5", fontWeight:"bold", textAlign:"right", borderBottom:"1px solid #d0d0d0"}}>نام و نام خانوادگی</th>
                                <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                    <div style={{transform:"rotate(270deg)", position:"absolute", top:"55px", left:"-30px", width:"90px"}}>نمره مثبت</div>                                    
                                </th>
                                <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                    <div style={{transform:"rotate(270deg)", position:"absolute", top:"55px", left:"-30px", width:"90px"}}>نمره منفی</div>                                    
                                </th>
                                {
                                    ((schoolClassDegree >=1) && (schoolClassDegree <=6))?
                                    <>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"55px", left:"-30px", width:"90px"}}>خیلی خوب</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"90px", left:"-30px", width:"90px"}}>خوب</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"55px", left:"-30px", width:"90px"}}>قابل قبول</div>                                    
                                    </th>
                                    <th style={{width:"35px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"bottom", position:"relative"}}>
                                        <div style={{transform:"rotate(270deg)", position:"absolute", top:"65px", left:"-45px", width:"120px"}}>نیاز به تلاش</div>                                    
                                    </th>
                                    </>
                                    :
                                    <th style={{minWidth:"70px", width:((schoolClassDegree >=1) && (schoolClassDegree <=6))? "180px" :"90px", backgroundColor:"#e5e5e5", fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0", verticalAlign:"middle", textAlign:"center"}}>
                                        نمره
                                    </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                continualTest.students.map((row, index)=>{
                                    return(
                                    <tr>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), fontWeight:"bold", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{(index+1)}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.nationalId}</td>
                                        <td style={{backgroundColor:(index%2==0?"#fff":"#f2f2f2"), padding:"5px", borderBottom:"1px solid #d0d0d0"}}>{row.student.firstname + " " + row.student.lastname}</td>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), color:"rgba(20, 151, 20, 1)", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            {continualTest.students[index].positiveScore}
                                        </td>
                                        <td style={{textAlign:"center", backgroundColor:(index%2==0?"#fff":"#f2f2f2"), color:"#F00", padding:"5px", borderBottom:"1px solid #d0d0d0"}}>
                                            {continualTest.students[index].negativeScore}
                                        </td>
                                        {createScoreGetter(index)}
                                    </tr>
                                    )
                                })
                            }
                            <tr><td colSpan={5}>&nbsp;</td></tr>
                        </tbody>
                    </table>

                </>
            }

        </Dialog>
    )
};

export default DisiplineScoreSave;